/* src/app/modules/tube/components/timeline/timeline.component.scss */
:host {
  display: grid;
  grid-template-columns: [title] 1.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto auto;
  gap: 0.2rem;
}
:host > * {
  align-self: center;
  justify-self: center;
  font-size: 12px;
  color: var(--text-primary);
}
.firstDate {
  grid-column: 2/5;
  grid-row: 1;
  margin-left: 0rem;
  justify-self: left;
  transform: translate(10%, 0);
}
.lastDate {
  grid-column: 5/9;
  grid-row: 1;
  margin-right: 0.5rem;
  justify-self: right;
}
.col1 {
  grid-column: 1;
  justify-self: left;
  margin-left: 0px;
  white-space: nowrap;
}
.day {
  display: block;
}
.day-mobile {
  display: none;
}
[screen-phone] :host-context {
  margin-right: 0.5rem;
}
[screen-phone] :host-context .day {
  display: none;
}
[screen-phone] :host-context .day-mobile {
  display: block;
}
/*# sourceMappingURL=timeline.component.css.map */
